// เลือกคู่ (docs/PLAN.md เฟส 3: ระบบหาคู่และลูก → เล่นต่อเป็นลูกของตัวเอง)
// คู่ที่เลือกมีผลกับลูกที่ผู้เล่นเล่นต่อ (startChildLife ใน src/engine/life.ts)
// strong = ลูกรอดง่ายตอนยังเล็ก · provider = ลูกเกิดมาอิ่ม · near = ปลอดภัยตอนนี้ แต่ลูกไม่ได้อะไรเพิ่ม

import type { GameEvent } from "../../engine/types";

export const FAMILY_EVENTS: readonly GameEvent[] = [
  {
    id: "choose_mate",
    stageTags: ["adult"],
    requires: { sessile: false, broadcastSpawn: false, notFlags: ["has_mate", "role_worker", "role_queen"] },
    weight: 10,
    text: "ฤดูผสมพันธุ์มาถึง มีสามตัวกำลังแข่งกันเรียกร้องความสนใจจากคุณ",
    fact: "สัตว์หลายชนิดเลือกคู่จากสัญญาณที่บอกว่าแข็งแรงจริง เช่น หางของนกยูงตัวผู้ หรือเสียงร้องที่ดังและนานของกบ ซึ่งต้องใช้พลังงานมากจึงแกล้งทำไม่ได้",
    choices: [
      {
        label: "ตัวที่แข็งแรงที่สุด",
        outcomes: [
          { chance: 0.6, text: "คุณได้คู่ที่แข็งแรงที่สุดในแถบนี้ ลูกๆ น่าจะแข็งแรงตาม", effects: { fullness: -10, addFlags: ["has_mate"], mate: "strong" } },
          { chance: 0.4, text: "ตัวอื่นก็หมายตาตัวนี้เหมือนกัน คุณต้องสู้จนบาดเจ็บ แล้วก็ไม่ได้คู่", effects: { health: -20, addFlags: ["injured"], cause: "accident" } },
        ],
      },
      {
        label: "ตัวที่หาอาหารเก่ง",
        outcomes: [
          { chance: 0.8, text: "คู่ของคุณนำอาหารมาฝากตั้งแต่วันแรก ลูกๆ คงไม่อดอยาก", effects: { fullness: 10, addFlags: ["has_mate"], mate: "provider" } },
          { chance: 0.2, text: "ตัวนี้สนใจแต่อาหารมากกว่าคุณ", effects: { fullness: 5 } },
        ],
      },
      {
        label: "ตัวที่อยู่ใกล้ที่สุด",
        outcomes: [{ chance: 1, text: "ไม่ต้องเดินทางไกลหรือแย่งกับใคร คุณได้คู่อย่างปลอดภัย", effects: { addFlags: ["has_mate"], mate: "near" } }],
      },
    ],
  },
];
